import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../data/translations';
import { usePageMeta } from '../hooks/usePageMeta';
import ScrollToTop from '../components/ScrollToTop';
import Reveal from '../components/Reveal';
import Hero from '../components/Hero';

const Terms = () => {
  const { currentLanguage } = useLanguage();
  const t = translations[currentLanguage].terms;
  usePageMeta({ title: t.title, description: t.introduction, path: 'terms' });

  const sectionKeys = ['scope', 'services', 'contract', 'payment', 'liability', 'rights', 'termination', 'law'];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <Hero gradientClass="hero-gradient-services" title={t.title} />

      {/* Content Section */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <Reveal>
          <p className="text-lg text-stone-700 mb-12 leading-relaxed">
            {t.introduction}
          </p>
        </Reveal>

        {/* Sections */}
        <div className="space-y-12">
          {sectionKeys.map((key) => (
            <Reveal as="section" key={key}>
              <h2 className="font-serif text-2xl font-bold text-stone-900 mb-6">{t.sections[key].title}</h2>
              <p className="text-stone-700 leading-relaxed">{t.sections[key].content}</p>
            </Reveal>
          ))}
        </div>

        {/* Contact Section */}
        <Reveal className="mt-12 pt-8 border-t border-stone-200">
          <p className="text-stone-500 text-center">
            {currentLanguage === 'de'
              ? 'Bei Fragen zu diesen AGB kontaktieren Sie uns unter info@alitero.eu'
              : currentLanguage === 'en'
              ? 'If you have any questions about these terms, please contact us at info@alitero.eu'
              : currentLanguage === 'sv'
              ? 'Om du har några frågor om dessa villkor, kontakta oss på info@alitero.eu'
              : 'Ha kérdése van ezekkel az feltételekkel kapcsolatban, vegye fel velünk a kapcsolatot a info@alitero.eu címen'}
          </p>
        </Reveal>
      </div>
      <ScrollToTop />
    </div>
  );
};

export default Terms;
